module.exports = __webpack_public_path__ + "static/img/10.8ffe235.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/doublelift/10.png
// module id = E6cJ
// module chunks = 38